import { Button as AntButton, Input, Tooltip } from 'antd';
import { CopyOutlined, InfoCircleOutlined } from '@ant-design/icons';
import { NotificationManager } from '../notification-manager';
import { Section } from '../form-fields/section';
import style from './style.module.scss';

export enum Brand {
    CoucheTard = 'coucheTard',
    CircleK = 'circleK',
}

const BRAND_CONFIG: Record<Brand, { logo: string; name: string }> = {
    [Brand.CoucheTard]: { logo: '/ct-logo-xl.svg', name: 'Couche-Tard' },
    [Brand.CircleK]: { logo: '/circle-k-xl-logo.svg', name: 'Circle K' },
};

export interface DeepLink {
    brand: Brand;
    url: string | null;
}

interface DeepLinkSectionProps {
    links: DeepLink[];
}

const copyToClipboard = (text: string) => {
    navigator.clipboard.writeText(text);
    NotificationManager.showSuccess('URL copied to clipboard');
};

export const DeepLinkSection = ({ links }: DeepLinkSectionProps) => {
    if (links.length === 0) {
        return null;
    }

    return (
        <Section
            title={
                <span>
                    Deep Link URL
                    <Tooltip title="Deep link URLs are automatically generated by the system. To generate a deep link, save the content with at least one province selected.">
                        <InfoCircleOutlined style={{ paddingLeft: '0.4rem' }} />
                    </Tooltip>
                </span>
            }
        >
            <div className={style.brand_list}>
                {links.map(({ brand, url }) => {
                    const config = BRAND_CONFIG[brand];
                    if (!config) return null;

                    const value = url ?? '';

                    return (
                        <div key={brand} className={style.brand_row}>
                            <div className={style.brand_header}>
                                <img
                                    src={config.logo}
                                    alt={config.name}
                                    className={style.brand_logo}
                                />
                                <span>{config.name}</span>
                            </div>
                            <div className={style.input_group}>
                                <Input
                                    value={value}
                                    disabled={true}
                                    size="large"
                                />
                                <AntButton
                                    type="default"
                                    icon={<CopyOutlined />}
                                    onClick={() => copyToClipboard(value)}
                                    disabled={!value}
                                    size="large"
                                    className={style.copy_button}
                                    data-copy-button="true"
                                />
                            </div>
                        </div>
                    );
                })}
            </div>
        </Section>
    );
};
